import {
  EDataManagementSemanticTypes,
  IReport,
  IReportConfiguration,
  IReportDatasetLens,
  ITemplatedSavedView,
  ITemplateReadable
} from '@opengov/reporting-types';
import { EReportPromptType } from '@opengov/reporting-types/src/standardTemplatePrompts';
import { produce } from 'immer';
import { v4 as uuidv4 } from 'uuid';

export const removeExtendedColumns = (reportConfiguration: IReportConfiguration): IReportConfiguration => {
  const filtered = reportConfiguration.detailTableQuery.columns.filter(
    (column) => !column.semanticTypes?.some((type) => type === EDataManagementSemanticTypes.extendedSchema)
  );

  return produce(reportConfiguration, (draft) => {
    draft.detailTableQuery.columns = filtered;
  });
};

export const createReportConfigurationTemplate = (params: {
  standardReportName: string;
  report: IReport;
  defaultReportConfiguration: IReportConfiguration;
  templatedSavedViews: ITemplatedSavedView[];
  lens: IReportDatasetLens;
}): ITemplateReadable => {
  if (!params) {
    return null;
  }

  return {
    enabled: true,
    id: process.env.NODE_ENV === 'test' ? '' : uuidv4(),
    createdAt: process.env.NODE_ENV === 'test' ? null : Date.now(),
    creator: 'Reporting Team',
    description: params.report.description,
    prompts: [
      { type: EReportPromptType.lens, outputVars: 'lensId' },
      { type: EReportPromptType.entityFiscalYearStart }
    ],
    updatedAt: process.env.NODE_ENV === 'test' ? null : Date.now(),
    standardReportName: params.standardReportName,
    report: {
      isDimensional: params.report.isDimensional,
      title: params.report.title,
      description: params.report.description,
      defaultReportConfiguration: params.defaultReportConfiguration
        ? removeExtendedColumns(params.defaultReportConfiguration)
        : null,
      visibility: params.report.visibility
    },
    savedViews: params.templatedSavedViews.map((savedView) => ({
      ...savedView,
      reportConfiguration: removeExtendedColumns(savedView.reportConfiguration)
    })),
    standardLensTypes: params.lens ? { lens: { lensType: params.lens.standardType } } : null
  };
};
